export default __webpack_public_path__ + "static/media/DSC_0070.0246e9db.jpg";